import ArtificialIntelligence from '../../assets/artificial-intelligence-collection.svg';

// @TODO: Replace hex values with theme variables once they are available - https://ecosystem.atlassian.net/browse/MC-4749
export const collections = [{
  id: 'articificial-intelligence',
  title: 'Artificial Intelligence',
  description: 'AI-powered apps that help you get more done',
  image: ArtificialIntelligence,
  backgroundColor: '#FFF8E3'
}, {
  id: 'collection-2',
  title: 'Atlassian Ventures',
  description: 'Atlassian Ventures is the next big thing',
  image: ArtificialIntelligence,
  backgroundColor: '#E9F2FE'
}, {
  id: 'collection-3',
  title: 'Project Management',
  description: 'Elevate productivity with cutting-edge AI apps. Empower tasks and workflows.',
  image: ArtificialIntelligence,
  backgroundColor: '#EFFFD6'
}];